module.exports = __webpack_public_path__ + "assets/doneCopy.f63f139ddf6c789d2a35ab5bec388b0f.png";